import { useAtom, useAtomValue, useSetAtom } from 'jotai';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

import { Option } from '@/lib/v2/components';

import {
  atomMoveCampaignPayload,
  atomSelectedActionsRowsWithID,
} from '@/modules/CampaignsModule/atoms/campaignAtom';
import { atomToggleMoveActionsModal } from '@/modules/CampaignsModule/atoms/modalsCampaignAtom';
import { useCampaignActions } from '@/modules/CampaignsModule/hooks/useCampaignActions';

export const useHandleEvents = () => {
  const { id } = useParams();
  const { moveAction, loading } = useCampaignActions({ campaignID: Number(id) });

  const actionId = useAtomValue(atomSelectedActionsRowsWithID);
  const [moveCampaignPayload, setMoveCampaignPayload] = useAtom(atomMoveCampaignPayload);
  const setToggleMoveActionsModal = useSetAtom(atomToggleMoveActionsModal);

  const handleCloseModal = useCallback(() => {
    setToggleMoveActionsModal(false);
  }, [setToggleMoveActionsModal]);

  const handleSubmitData = useCallback(async () => {
    if (!moveCampaignPayload) return;

    await moveAction(moveCampaignPayload);
    handleCloseModal();
  }, [handleCloseModal, moveAction, moveCampaignPayload]);

  const handleChangeCampaigns = (value: Option | Option[]) => {
    const data = value as Option;
    /** cspell:disable */
    setMoveCampaignPayload({ campaniaId: Number(data.id), elementosId: actionId });
    /** cspell:enable */
  };

  return {
    handleCloseModal,
    handleSubmitData,
    handleChangeCampaigns,
    loading,
  };
};
